import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CitaContext } from '../context/CitaContext';
import Confirmacion from '../components/cliente/Confirmacion';

const ConfirmacionCita = () => {
  const { 
    servicioSeleccionado, 
    metodoPago
  } = useContext(CitaContext);
  
  const navigate = useNavigate();
  
  // Redireccionar si no hay datos completos
  useEffect(() => {
    if (!servicioSeleccionado || !metodoPago) {
      navigate('/servicios');
    }
  }, [servicioSeleccionado, metodoPago, navigate]);
  
  if (!servicioSeleccionado || !metodoPago) {
    return null;
  }
  
  return (
    <div className="booking-page">
      <header className="booking-topbar">
        <div className="booking-topbar-inner">
          <div>
            <h2 className="booking-topbar-title">Sistema de Citas Medicas</h2>
            <p className="booking-topbar-subtitle">Confirmacion final de tu cita</p>
          </div>
          <div className="booking-step-badge">
            <i className="fas fa-check-circle"></i>
            <span>Paso 4 de 4</span>
          </div>
        </div>
      </header>

      <main className="booking-main">
        <div className="booking-panel">
          <div className="booking-content">
            <Confirmacion />
          </div>
        </div>
      </main>

      <footer className="booking-footer">
        <p>Copyright 2025 - BM Creatividad</p>
      </footer>
    </div>
  );
};

export default ConfirmacionCita;